import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const submitLead = (data) => client.post("/leads", data).then((r) => r.data);
export const submitStaffing = (data) =>
  client.post("/staffing-requirements", data).then((r) => r.data);
export const submitApplication = (formData) =>
  client
    .post("/applications", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);

export const adminSummary = (key) =>
  client.get("/admin/summary", { params: { key } }).then((r) => r.data);
export const adminList = (type, key) =>
  client.get(`/admin/${type}`, { params: { key } }).then((r) => r.data);
export const adminUpdateStatus = (id, body, key) =>
  client.patch(`/admin/applications/${id}/status`, body, { params: { key } }).then((r) => r.data);
export const adminAddNote = (id, note, key) =>
  client.post(`/admin/applications/${id}/note`, { note }, { params: { key } }).then((r) => r.data);

// ---------- Candidate portal auth ----------
const TOKEN_KEY = "amvi_candidate_jwt";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const requestMagicLink = (email) =>
  client.post("/auth/request-link", { email }).then((r) => r.data);
export const verifyMagicLink = (token) =>
  client.post("/auth/verify", { token }).then((r) => r.data);
export const portalMe = () => client.get("/portal/me", authHeaders()).then((r) => r.data);
export const portalApplications = () =>
  client.get("/portal/applications", authHeaders()).then((r) => r.data);
export const updateProfile = (data) =>
  client.patch("/portal/profile", data, authHeaders()).then((r) => r.data);
export const uploadPortalResume = (formData) =>
  client
    .post("/portal/resume", formData, {
      headers: { ...authHeaders().headers, "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
export const getSaved = () => client.get("/portal/saved", authHeaders()).then((r) => r.data);
export const addSaved = (slug) => client.post("/portal/saved", { slug }, authHeaders()).then((r) => r.data);
export const removeSaved = (slug) => client.delete(`/portal/saved/${slug}`, authHeaders()).then((r) => r.data);
export const withdrawApplication = (id) =>
  client.post(`/portal/applications/${id}/withdraw`, {}, authHeaders()).then((r) => r.data);
export const adminSendDigest = (key) =>
  client.post("/admin/send-digest", {}, { params: { key } }).then((r) => r.data);
export const adminSetInterviewSlots = (id, body, key) =>
  client.post(`/admin/applications/${id}/interview-slots`, body, { params: { key } }).then((r) => r.data);
export const bookInterview = (id, slot) =>
  client.post(`/portal/applications/${id}/book-interview`, { slot }, authHeaders()).then((r) => r.data);

// ---------- Content CMS ----------
export const fetchContent = (kind) =>
  client.get(`/content/${kind}`).then((r) => r.data.items || []);
export const seedContent = (kind, items, key) =>
  client.post(`/admin/content/${kind}/seed`, { items }, { params: { key } }).then((r) => r.data);
export const createContent = (kind, item, key) =>
  client.post(`/admin/content/${kind}`, item, { params: { key } }).then((r) => r.data);
export const updateContent = (kind, slug, item, key) =>
  client.put(`/admin/content/${kind}/${slug}`, item, { params: { key } }).then((r) => r.data);
export const deleteContent = (kind, slug, key) =>
  client.delete(`/admin/content/${kind}/${slug}`, { params: { key } }).then((r) => r.data);
export const uploadContentImage = (file, key) => {
  const fd = new FormData();
  fd.append("image", file);
  return client
    .post("/admin/upload-image", fd, {
      params: { key },
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const contentImageUrl = (path) => `${API}/content-image/${path}`;
export const reorderContent = (kind, slugs, key) =>
  client.post("/admin/reorder", { kind, slugs }, { params: { key } }).then((r) => r.data);
export const getAvailability = (key) =>
  client.get("/admin/availability", { params: { key } }).then((r) => r.data);
export const saveAvailability = (body, key) =>
  client.put("/admin/availability", body, { params: { key } }).then((r) => r.data);
export const adminSendReminders = (key) =>
  client.post("/admin/send-reminders", {}, { params: { key } }).then((r) => r.data);
export const bulkAction = (ids, status, sendInvites, key) =>
  client.post("/admin/applications/bulk", { ids, status, send_invites: sendInvites }, { params: { key } }).then((r) => r.data);
export const requestReschedule = (id, message) =>
  client.post(`/portal/applications/${id}/request-reschedule`, { message }, authHeaders()).then((r) => r.data);
export const getSchedulingStats = (key) =>
  client.get("/admin/scheduling-stats", { params: { key } }).then((r) => r.data);
export const downloadResumesZip = (ids, key) =>
  client.post("/admin/applications/resumes-zip", { ids }, { params: { key }, responseType: "blob" }).then((r) => r.data);

// ---------- Job Alerts ----------
export const subscribeJobAlerts = (email, skills) =>
  client.post("/job-alerts/subscribe", { email, skills }).then((r) => r.data);

export default client;
